"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.responsiveStyle = exports.responsiveValue = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
/*
 * If we want to turn an object with breakpoints as keys
 * and return only the value of the current breakpoint, use this
 */


var responsiveValue = function responsiveValue(styles) {
  return function (props) {
    var sortedBreakpoints = Object.entries(props.theme.breakpoints).sort(function (_ref, _ref2) {
      var _ref3 = (0, _slicedToArray2["default"])(_ref, 2),
          valA = _ref3[1];

      var _ref4 = (0, _slicedToArray2["default"])(_ref2, 2),
          valB = _ref4[1];

      return valA - valB;
    }).map(function (_ref5) {
      var _ref6 = (0, _slicedToArray2["default"])(_ref5, 1),
          key = _ref6[0];

      return key;
    }); // want to return the style closest to the current breakpoint, without going over
    // loop through every breakpoint backwards, starting with the current breakpoint

    for (var i = sortedBreakpoints.indexOf(props.theme.breakpoint); i >= 0; i -= 1) {
      if (styles[sortedBreakpoints[i]] !== undefined) {
        return styles[sortedBreakpoints[i]];
      }
    }

    console.error("Unable to find a responsvie value");
    return undefined;
  };
};
/*
 * If we want to turn a css key (the first arg)
 * and an object with breakpoints as keys (the second arg)
 * into a single key-value css declaration, use this
 */


exports.responsiveValue = responsiveValue;

var responsiveStyle = function responsiveStyle(key, styles) {
  return function (props) {
    var newStyle = [];
    Object.entries(props.theme.breakpoints).forEach(function (_ref7) {
      var _ref8 = (0, _slicedToArray2["default"])(_ref7, 2),
          breakpointKey = _ref8[0],
          breakpointVal = _ref8[1];

      if (styles[breakpointKey] !== undefined) {
        if (breakpointVal === 0) {
          newStyle.push("".concat(key, ": ").concat(styles[breakpointKey], ";"));
        } else {
          newStyle.push("@media screen and (min-width: ".concat(breakpointVal, "px) { ").concat(key, ": ").concat(styles[breakpointKey], "; }"));
        }
      }
    });
    return newStyle;
  };
};

exports.responsiveStyle = responsiveStyle;